import React, { createContext, useContext, ReactNode } from 'react';

// 1. Define the config type
export interface Config {
  appName: string;
  knowledgeBaseUrl: string
  guidesUrl: string
}

// 2. Default config
const defaultConfig: Config = {
  appName: `${process.env.REACT_APP_APP_NAME}`,
  knowledgeBaseUrl: 'https://learn.rimo3.com/knowledge-base/setting-up-clarity',
  guidesUrl: 'https://learn.rimo3.com/knowledge-base/intune-clarity-guides'
};

// 3. Create context
const ConfigContext = createContext<Config>(defaultConfig);

// 4. Provider props
interface ConfigProviderProps {
  children: ReactNode;
  config?: Config;
}

// 5. Provider component
export const ConfigProvider: React.FC<ConfigProviderProps> = ({
  children,
  config = defaultConfig,
}) => {
  return (
    <ConfigContext.Provider value={config}>
      {children}
    </ConfigContext.Provider>
  );
};

// 6. Custom hook
export const useConfig = (): Config => useContext(ConfigContext);